import React, { useContext } from "react";
import { Button, Comment, Timeline } from "antd";
import { DATA_FORMATO, STATUS } from "../../../utils";
import { ClockCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { UserContext } from "../../../contexts/UserContext";


const anonPalavrasEscondidas = new Set(["de", "da", "do", "dos", "das", "e"]);

function anonimizarNome(nome) {
  if (!nome || typeof nome !== "string") return "Usuário anônimo";

  return nome
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((parte) => {
      const lower = parte.toLowerCase();
      if (anonPalavrasEscondidas.has(lower)) return parte;
      if (parte.length <= 1) return parte;
      return parte[0] + "*".repeat(parte.length - 1);
    })
    .join(" ");
}

function anonimizarTexto(texto, nomeReal) {
  if (!texto || typeof texto !== "string") return texto;
  if (!nomeReal || typeof nomeReal !== "string") return texto;

  const nomeAnon = anonimizarNome(nomeReal);
  return texto.split(nomeReal).join(nomeAnon);
}

function isOisolMaster(user) {
  const target1 = "OISOL.MASTER";
  const target2 = "OISOL_MASTER";

  const norm = (v) => (typeof v === "string" ? v.trim().toUpperCase() : null);

  const authorityValues = Array.isArray(user?.authorities) ? user.authorities : [];
  const authorityStrings = authorityValues.map((a) => {
    if (typeof a === "string") return a;
    return a?.authority || a?.grupo || a?.group || a?.name || a?.code || null;
  });

  const groupValues = []
    .concat(user?.grupos || [])
    .concat(user?.groups || [])
    .filter(Boolean)
    .map((g) => {
      if (typeof g === "string") return g;
      return (
        g?.nome ||
        g?.name ||
        g?.group ||
        g?.groupName ||
        g?.authority ||
        g?.authorityName ||
        g?.grupo ||
        g?.value ||
        null
      );
    })
    .filter(Boolean);

  const candidates = [
    user?.grupo,
    user?.group,
    ...authorityStrings,
    ...groupValues,
  ];

  return candidates.some((c) => {
    const s = norm(c);
    return s === target1 || s === target2;
  });
}

export const TimelineProgressoEncaminhamento = ({ statusCurrent, dataConclusao, progresso, dataInicio, titulo }) =>  {
    const { user } = useContext(UserContext);
    const master = isOisolMaster(user);

    return (
        <>  
            <h3>{titulo}</h3>
            <Timeline
                mode="left"
                style={{ marginTop: "1.5rem", marginLeft: "-5rem" }}
            >
                {statusCurrent === STATUS.FINALIZADO && (
                <Timeline.Item
                    dot={<ClockCircleOutlined style={{ fontSize: "15px" }} />}
                    color="red"
                    label={moment(dataConclusao).format(DATA_FORMATO)}
                >
                    ENCAMINHAMENTO FINALIZADO!
                </Timeline.Item>
                )}
                {progresso
                .sort(
                    (a, b) =>
                    new Date(b.dataCadastro) - new Date(a.dataCadastro)
                )
                .map((justificativa, index) => {
                  const nomeReal =
                    justificativa?.usuario?.nome ||
                    justificativa?.usuario?.nome_completo ||
                    justificativa?.usuario?.nomeCompleto;

                  const author = master ? nomeReal || "Usuário" : anonimizarNome(nomeReal);
                  const content = master
                    ? justificativa.descricao
                    : anonimizarTexto(justificativa.descricao, nomeReal);

                  return (
                    <Timeline.Item
                      position={justificativa.cor === "blue" && "letf"}
                      color={justificativa.cor}
                      label={justificativa.tipo}
                    >
                      <Comment
                        author={author}
                        content={content}
                        datetime={justificativa.dataCadastro}
                      />
                    </Timeline.Item>
                  );
                })}

                <Timeline.Item
                dot={<ClockCircleOutlined style={{ fontSize: "15px" }} />}
                color="green"
                label={moment(dataInicio).format(DATA_FORMATO)}
                >
                ENCAMINHAMENTO REALIZADO!
                </Timeline.Item>
            </Timeline>
            {statusCurrent === STATUS.FINALIZADO && (
                <Button style={{ display: "none" }} type="dashed" danger>
                REABRIR ENCAMINHAMENTO
                </Button>
            )}
        </>
    );
};